export default __webpack_public_path__ + "static/media/eswitch.1afd891e.svg";